var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpsidedowntriangleMint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "33.87499999999997 39.26404494382024 203.25000000000003 169.24157303370788",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    width: "203.25000000000003px",
    height: "169.24157303370788px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Master/Background/Abstract 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.882 62.7465L57.4079 62.5825C52.4929 62.5715 49.4099 67.8855 51.8579 72.1465L89.9519 138.459L128.047 204.769C130.495 209.031 136.639 209.044 139.106 204.793L177.486 138.647L215.865 72.5005C218.332 68.2495 215.271 62.9225 210.356 62.9115L133.882 62.7465Z",
    fill: "#d6f0e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(27 78.8994) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(62.7617 118) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(143.762 87) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(160.762 35) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(184.762 41) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(219.762 41) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(95.7617 44) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Decoration",
    transform: "translate(65.7617 34) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decoration/Triangle 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70812 8.69876L14.1146 8.37578C15.1974 8.31036 15.9806 9.40516 15.4694 10.3643L13.0683 14.8818C12.5768 15.8057 11.2394 15.8861 10.6285 15.0351L7.62564 10.8407C6.988 9.95234 7.61934 8.76454 8.70812 8.69876ZM14.1898 9.62753L8.78334 9.9505C8.64969 9.95857 8.60135 10.0495 8.64482 10.1101L11.6477 14.3045C11.7186 14.4032 11.9085 14.3918 11.9611 14.293L14.3624 9.77516C14.3956 9.7128 14.3286 9.61914 14.1898 9.62753Z",
    fill: "#ff8ba2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Medium Decoration",
    transform: "translate(165.762 154.973) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium Decoration/Cloud 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3369 23.1061C30.206 21.9662 30.159 20.9429 29.7363 19.985C28.6022 17.4107 26.5118 16.7925 24.0546 17.0558C21.9872 17.279 20.8371 18.7546 20.1875 20.6182C19.8178 21.6787 19.571 22.0034 18.5338 21.2475C16.891 20.0493 15.1084 20.2634 13.5136 21.3912C11.7449 22.6427 11.0545 24.4932 11.3482 26.6765C11.4661 27.5551 11.5211 28.4527 11.8918 29.2398C11.4831 29.5453 11.2333 29.283 10.9765 29.2056C9.36673 28.7191 7.9458 29.1463 6.95855 30.4369C5.89136 31.8342 5.71149 33.9059 6.43794 35.294C6.83065 36.0419 7.42919 35.9524 8.04373 35.9524C14.9505 35.9544 21.8573 35.9534 28.7631 35.9534C37.3746 35.9534 45.987 35.9585 54.5995 35.9434C55.0562 35.9424 55.6887 36.2148 55.9245 35.5735C56.1514 34.9573 55.8316 34.3924 55.4339 33.927C54.6225 32.974 53.5044 32.5649 52.3692 32.3187C50.7175 31.9608 49.5683 31.0652 48.638 29.6006C47.389 27.6345 45.6063 26.2272 43.2171 26.6554C41.6473 26.9369 40.4292 27.2012 39.2681 25.6532C38.7395 24.9506 37.5574 24.828 36.5911 25.3808C36.2264 25.5899 35.9366 25.6552 35.7778 25.0541C34.9014 21.7601 33.0368 21.0565 30.3369 23.1061",
    fill: "#d6f0e3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsidedowntriangleMint);
export default __webpack_public_path__ + "static/media/UpsidedowntriangleMINT.b365e6cb.svg";
export { ForwardRef as ReactComponent };